module.exports = __webpack_public_path__ + "images/bdfffd8f9b88ef6703d0ba4b53406c7d.jpg";